export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-5xl md:text-5xl font-semibold text-gray-100">404</h1>
        <h1 className="text-2xl md:text-3xl font-semibold mt-6">页面未生成</h1>
        <p className="mt-4 text-xl md:text-2xl text-gray-500">请告知您希望在此页面展示的内容</p>
      </div>
    );
  }
